import { API, getRequest, postRequest } from '@/api/api';

import type { TagDto } from './tags.dto';
import { type EventTag, mapTag } from './tags.mappers';

export const getTags = async (): Promise<EventTag[]> => {
  const response = await getRequest<TagDto[]>(API.ACTIVITY, `/tags`);
  return (response.data ?? []).map(mapTag);
};

/**
 * A tag of the vessel's own. activity answers 409 when the name is taken — by
 * another tag of the vessel or by a default tag.
 */
export const createTag = async (name: string): Promise<EventTag> => {
  const response = await postRequest<TagDto, { name: string }>(API.ACTIVITY, `/tags`, { name });
  return mapTag(response.data);
};
